export class KeyedTaskQueue {
  private readonly queues = new Map<string, Promise<void>>();

  async run(key: string, operation: () => Promise<void>): Promise<void> {
    const previous = this.queues.get(key) ?? Promise.resolve();
    const queued = previous.catch(() => undefined).then(operation);
    this.queues.set(key, queued);
    try {
      await queued;
    } finally {
      if (this.queues.get(key) === queued) this.queues.delete(key);
    }
  }

  async drain(): Promise<void> {
    while (this.queues.size > 0) {
      const pending = Array.from(new Set(this.queues.values()));
      const results = await Promise.allSettled(pending);
      const failure = results.find((result): result is PromiseRejectedResult => result.status === "rejected");
      if (failure) throw failure.reason;
    }
  }
}
